import React, {ReactNode} from 'react';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import type {ToggleButtonGroupProps as MuiToggleButtonGroupProps} from '@mui/material/ToggleButtonGroup';
import {styled} from '@mui/material/styles';
import {ToggleButton} from './ToggleButton';

export interface ToggleButtonGroupProps extends Omit<MuiToggleButtonGroupProps, 'orientation' | 'color'> {
    isCentered?: boolean;
}

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)<ToggleButtonGroupProps>(({theme}) => ({
    '&.MuiToggleButtonGroup-root': {
        boxShadow: theme.tokens.FuelShadowSm
    }
}));

export const ToggleButtonGroup = React.forwardRef<any, ToggleButtonGroupProps>(({
    children, value, isCentered, ...props
}, ref) => (
    <StyledToggleButtonGroup
        {...props}
        ref={ref}
        value={value}
    >
        {React.Children.toArray(children).map<ReactNode | typeof ToggleButton>((child) => {
            if (React.isValidElement(child)) {
                if (child.type === ToggleButton) {
                    return React.cloneElement(child, {
                        isCentered,
                        ...child.props // child props to override cloned props
                    });
                }
            }

            return child;
        })}
    </StyledToggleButtonGroup>
));

ToggleButtonGroup.displayName = 'ToggleButtonGroup';
